<template>
    <a-layout-header :class="[headerTheme, 'admin-header']">
        <div :class="['admin-header-wide', layout, pageWidth]">
            <a-icon v-if="(layout !== 'head' && isMobile !== false) || !isMobile" class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggleCollapse" />

            <div :class="['admin-header-right', headerTheme]">
                <a-dropdown style="margin-right: 20px;">
                    <div>
                        <a-button shape="round" size="small">
                            <span class="name">{{ activeModule.module.labels.title }} <a-icon type="down" /></span>
                        </a-button>
                    </div>
                    <a-menu slot="overlay">
                        <a-menu-item v-for="modules in trainingModules" :key="modules.id">
                            <a href="javascript:void(null);" @click="assignKpi(modules.module.identifier)">
                                <span>{{ modules.module.labels.title }}</span>
                            </a>
                        </a-menu-item>
                    </a-menu>
                </a-dropdown>

                <header-notification :src="routeUri('api.notification.unread')" />
                <header-user class="header-item"/>
            </div>
        </div>
    </a-layout-header>
</template>
<script>
export default {
    props: {
        theme: {
            type: String,
            required: false,
            default: ''
        },
        collapsed: {
            type: Boolean,
            required: true
        }
    },
    computed: {
        pageWidth() {
            return this.config.layout.width
        },
        layout() {
            return this.config.layout.mode
        },
        headerTheme() {
            return this.theme === '' ? this.config.layout.header.theme : this.theme
        },
        trainingModules() {
            return this.$laravel.training_modules
        },
        activeModule() {
            return this.$laravel.active_module
        }
    },
    methods: {
        assignKpi(kpi){
            this.$http.patch(this.routeUri('api.general.patch'), {
                module : kpi,
            })
                .then((r) => window.location.href = window.location.origin + this.routeUri('admin.dashboard'))
        },
        toggleCollapse () {
            this.$emit('toggleCollapse')
        },
    }
}
</script>
